/* 中间页、跳板页 相关接口 */
import http from '@/assets/plugins/axios'
import {backendUrl} from '@/assets/js/config'
export default {
  // 1. 获取 管理员信息
  getAdminInfo (params) {
    // return http.get(`${backendUrl}/user/personal/get_admin`)
    return http.get(`${backendUrl}/user/personal/admin_info`, params)
  },
  // 2. 下载开通员工账号操作说明
  downloadOpenAccount () {
    return `${backendUrl}/common/open_employee_account_doc`
  },
  // 3. 下载管理员账号绑定说明
  downloadBindAccount () {
    return `${backendUrl}/common/bind_admin_account_doc`
  }
}

